import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom/dist';
import Loader from '../../components/Loader/Loader';
import { useNavigate } from 'react-router-dom';
import TeacherWrapper from '../TeacherWrapper';
const SingleCourceDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [courseDetails, setCourseDetails] = useState();
  const [loader, setLoader] = useState(false);
  const [additionalImages, setAdditionalImages] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  useEffect(() => {
    fetchCourseDetails(id);
    fetchAdditionalImages(id);
  }, [id]);
  const fetchCourseDetails = (courseId) => {
    setLoader(true);
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch(`https://quran-backend-theta.vercel.app/v1/user/course/${courseId}`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        console.log('DATA', data?.course);
        setCourseDetails(data?.course);
        setLoader(false);
      })
      .catch((error) => console.error(error));
  };

  const fetchAdditionalImages = async (id) => {
    try {
      const response = await fetch(
        `https://quran-backend-theta.vercel.app/v1/admin/course-additional-images/${id}`
      );
      const data = await response.json();

      if (data.success) {
        setAdditionalImages(data.additionalImages);
      } else {
        console.error('Failed to fetch additional images');
      }
    } catch (error) {
      console.error('Error fetching additional images:', error);
    }
  };

  const handleAddMoreImages = async (event) => {
    const file = event.target.files[0];

    if (!file) return;

    setIsUploading(true); // Start Loading

    try {
      const formData = new FormData();
      formData.append('images', file);

      const requestOptions = {
        method: 'POST',
        body: formData
      };

      const response = await fetch(
        'https://file-upload-ashen.vercel.app/api/upload',
        requestOptions
      );
      const result = await response.json();

      if (!result.success) {
        toast.error('Error While Upload Images');
        return;
      }

      const myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');

      const raw = JSON.stringify({
        imageUrl: result?.data[0]
      });

      const updateOptions = {
        method: 'PUT',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };

      const updateResponse = await fetch(
        `https://quran-backend-theta.vercel.app/v1/admin/add-additional-images/${id}`,
        updateOptions
      );
      const updateResult = await updateResponse.text();
      let data = JSON.parse(updateResult);

      if (!data.success) {
        toast.error(data.message);
      } else {
        const newImage = {
          id: Date.now(),
          url: URL.createObjectURL(file),
          name: file.name,
          size: file.size,
          type: file.type
        };

        setAdditionalImages((prev) => [...prev, newImage]);
        window.location.reload();
      }
    } catch (error) {
      console.error('Upload Error:', error);
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <TeacherWrapper>
      <h2 className="main_title ">{courseDetails?.name}</h2>
      <p className=" text-[#1C1D1D]">Here are details of your courses</p>

      <section>
        <div className=" flex justify-between  py-3 items-center">
          <div className="">
            <p className=" text-lg m-0">Cource Details</p>
          </div>
          {loader === true ? <Loader /> : null}
        </div>

        <div className=" p-3 rounded-lg" style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}>
          <span className=" m-0 text-gray-400 text-sm">Cource Name</span>
          <h6 className=" text-lg">{courseDetails?.name}</h6>

          <span className=" pt-3 m-0 text-gray-400 text-sm">Description</span>
          <h6 className="">{courseDetails?.description}</h6>
          <ul className=" flex flex-col gap-2 mt-5">
            <li>
              <span className=" m-0 text-gray-400 text-sm">Price</span>
              <p>$ {courseDetails?.price}</p>
            </li>
            <li>
              <span className=" m-0 text-gray-400 text-sm">Lessons</span>
              <p>{courseDetails?.lesson}</p>
            </li>
            <li>
              <span className=" m-0 text-gray-400 text-sm">Duration</span>
              <p>
                {courseDetails?.duration} {courseDetails?.periodType}
              </p>
            </li>
          </ul>
          <div className="mt-6">
            <h3 className="text-lg font-bold">Additional Images</h3>
            <div className="grid grid-cols-3 gap-4 mt-4">
              {additionalImages.length > 0 ? (
                additionalImages.map((image) => (
                  <div key={image.id} className="relative">
                    <img
                      src={image.url}
                      alt={image.name}
                      className="w-full h-60 object-cover rounded-md"
                    />
                  </div>
                ))
              ) : (
                <p>No additional images available.</p>
              )}
            </div>
          </div>
        </div>
      </section>
    </TeacherWrapper>
  );
};

export default SingleCourceDetails;
